import { queryOptions } from "@tanstack/react-query";
import { apiFetch } from "@/api/client";
import type { Tenant } from "@/schemas/models/tenant";

export const tenantKeys = {
  all: () => ["tenants"] as const,
  lists: () => [...tenantKeys.all(), "list"] as const,
  details: () => [...tenantKeys.all(), "detail"] as const,
};

export const tenantQueries = {
  list: (filters?: { search?: string }) =>
    queryOptions({
      queryKey: filters
        ? ([...tenantKeys.lists(), filters] as const)
        : tenantKeys.lists(),
      queryFn: () => apiFetch<Tenant[]>("/api/tenants"),
    }),
  detail: (id: string) =>
    queryOptions({
      queryKey: [...tenantKeys.details(), id] as const,
      queryFn: () => apiFetch<Tenant>(`/api/tenants/${id}`),
      staleTime: 5 * 60 * 1000,
    }),
};
